import React, { MouseEvent, FC, memo } from 'react'

import clsx from 'clsx'

import CommonSvg from '@style-port/roov-ui-components-core/assets/svg/common.svg'
import WorksSvg from '@style-port/roov-ui-components-core/assets/svg/works.svg'
import { Icon as RoovIcon } from '@style-port/roov-ui-components-react'

import styles from './icon.module.scss'

type Props = {
  path: string
  size?: string
  basePath?: 'common' | 'works'
  onClick?: (event: MouseEvent) => void
  className?: string
}

export const Icon: FC<Props> = memo(
  ({ path, size = '--r0', basePath = 'common', onClick, className }) => {
    const base = basePath === 'common' ? CommonSvg : WorksSvg

    // TODO:
    //  sizeそのままRoovIconに渡すとSSR時にwidth・heightに関する設定がされず、一瞬大きく表示されてしまうため、sizeに対するtailwindのクラスを当てる
    //  根本対応としてはSSR時もui-components側でサイズが設定されるようにする

    // size に応じて tw-w-*, tw-h-* を設定する
    const sizeClass =
      size === '--r-1'
        ? `tw-w-r-1 tw-h-r-1`
        : size === '--r0'
        ? `tw-w-r0 tw-h-r0`
        : size === '--r1'
        ? `tw-w-r1 tw-h-r1`
        : size === '--r2'
        ? `tw-w-r2 tw-h-r2`
        : size === '--r3'
        ? `tw-w-r3 tw-h-r3`
        : size === '--r4'
        ? `tw-w-r4 tw-h-r4`
        : size === '--s0'
        ? `tw-w-s0 tw-h-s0`
        : size === '--s1'
        ? `tw-w-s1 tw-h-s1`
        : size === '--s2'
        ? `tw-w-s2 tw-h-s2`
        : size === '--s3'
        ? `tw-w-s3 tw-h-s3`
        : size === '--s4'
        ? `tw-w-s4 tw-h-s4`
        : ''

    return (
      // styles.container でui-components側で行っているサイズに関する設定を行う
      <RoovIcon onClick={onClick} className={clsx(sizeClass, styles.container, className)}>
        <svg>
          <use href={`${base}#${basePath}/${path}`} />
        </svg>
      </RoovIcon>
    )
  }
)
